function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M63.67,23.06l-10.41-10.41c-1.56-1.57-3.69-2.44-5.9-2.44h-14.72c-2.21,0-4.34.88-5.9,2.44l-10.41,10.41c-1.56,1.57-2.44,3.69-2.44,5.9v14.72c0,2.21.88,4.34,2.44,5.9l9.06,9.06-4.71,8.15h-2.37c-.83,0-1.5.67-1.5,1.5s.67,1.5,1.5,1.5h43.39c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5h-2.37l-4.71-8.16,9.06-9.06c1.56-1.57,2.44-3.69,2.44-5.9v-14.72c0-2.21-.88-4.34-2.44-5.9ZM52.83,30.12c0,1.84-1.49,3.33-3.33,3.33s-3.33-1.49-3.33-3.33,1.49-3.33,3.33-3.33,3.33,1.49,3.33,3.33ZM44.94,17.26c1.84,0,3.33,1.49,3.33,3.33s-1.49,3.33-3.33,3.33-3.33-1.49-3.33-3.33,1.49-3.33,3.33-3.33ZM27.2,22.85c1.84,0,3.33,1.49,3.33,3.33s-1.49,3.33-3.33,3.33-3.33-1.49-3.33-3.33,1.49-3.33,3.33-3.33ZM21.04,37.11c0-1.84,1.49-3.33,3.33-3.33s3.33,1.49,3.33,3.33-1.49,3.33-3.33,3.33-3.33-1.49-3.33-3.33ZM23.87,44.27c0-1.84,1.49-3.33,3.33-3.33s3.33,1.49,3.33,3.33-1.49,3.33-3.33,3.33-3.33-1.49-3.33-3.33ZM55.86,66.8h-31.72l3.49-6.04c1.44,1.08,3.19,1.69,5.01,1.69h14.72c1.82,0,3.57-.6,5.01-1.69l3.49,6.04ZM38.54,50.93c1.84,0,3.33,1.49,3.33,3.33s-1.49,3.33-3.33,3.33-3.33-1.49-3.33-3.33,1.49-3.33,3.33-3.33ZM52.81,55.51c.41.72.17,1.63-.55,2.05-.24.14-.49.2-.75.2-.52,0-1.02-.27-1.3-.75,0,0,0,0,0,0l-8.92-15.45c-.42.1-.85.16-1.29.16s-.88-.06-1.29-.16h0l-8.92,15.45c-.41.72-1.33.96-2.05.55-.72-.41-.96-1.33-.55-2.05,0,0,0,0,0,0l8.92-15.45c-.93-.97-1.51-2.29-1.51-3.74,0-2.98,2.42-5.4,5.4-5.4s5.4,2.42,5.4,5.4c0,1.45-.58,2.77-1.51,3.74,0,0,0,0,0,0l8.92,15.45ZM55.82,46.32c-1.84,0-3.33-1.49-3.33-3.33s1.49-3.33,3.33-3.33,3.33,1.49,3.33,3.33-1.49,3.33-3.33,3.33Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M40,33.92c-1.33,0-2.4,1.08-2.4,2.4,0,.31.06.6.17.87h0c.35.89,1.22,1.53,2.23,1.53s1.88-.64,2.23-1.53h0c.11-.27.17-.56.17-.87,0-1.33-1.08-2.4-2.4-2.4Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/Lottery-active.426697d1.svg";
export { SvgComponent as ReactComponent };